import * as React from 'react'
import { FieldInputProps, FormikHelpers, FormikValues } from 'formik'

import './rangeInput.sass'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import isMobile from 'is-mobile'
import { openMenu } from '../../../store/common/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'
import { GeoState } from '../../../store/geo/geoTypings'

interface Props {
    text?: string
    field?: FieldInputProps<string>
    form?: FormikHelpers<FormikValues>
    onClick?: () => void
    type?: string
    initialValue: number
    maxRange: string
    notActive?: boolean
}

const RangeInput: React.FunctionComponent<Props> = ({
    form,
    field,
    text,
    type,
    initialValue = 0,
    maxRange = '0',
    notActive = false
}: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const { loggedIn } = useSelector((state: RootState) => state.member)
    const [rangeValue, setRangeValue] = useState(initialValue)
    const [inputWidth, setInputwidth] = useState(0)
    const range = useRef(null)
    const [isBlinking, setIsBlinking] = useState(false)
    const { filters } = useSelector<RootState, GeoState>((state) => state.geo)

    useEffect(() => {
        if (rangeValue > Number(maxRange)) setRangeValue(Number(maxRange))
    }, [])

    useEffect(() => {
        if (range.current) setInputwidth(range.current.offsetWidth)
    })
    // @ts-ignore
    useEffect(() => {
        // if (type !== 'mobile') {
        const delaySubmit = setTimeout(() => {
            form.submitForm()
            form.setFieldValue(field.name, rangeValue)
        }, 1000)

        return () => clearTimeout(delaySubmit)
        // }
        // @ts-ignore
    }, [rangeValue])
    return (
        <div
            className={notActive ? 'rangeWrapper' : 'rangeWrapper notActiveRange'}
            onClick={() => {
                if (!loggedIn) dispatch(openMenu())
            }}
        >
            <p>{text}</p>
            <div className={'range'}>
                <input
                    ref={range}
                    type="range"
                    min={'0'}
                    max={maxRange}
                    value={rangeValue}
                    onChange={(event) => {
                        if (notActive) {
                            if (isMobile()) {
                                // @ts-ignore
                                setRangeValue(event.target.value)
                            } else {
                                if (Number(event.target.value) > 1000) {
                                    setRangeValue(Number(event.target.value))
                                } else {
                                    setRangeValue(1000)
                                }
                            }
                            // form.setFieldValue(field.name, rangeValue)
                        }
                        // blinks
                        if (!isMobile() && filters && filters.shareMyLocation == 1 && rangeValue === 1000) {
                            setIsBlinking(true)
                        } else {
                            if (isBlinking) setIsBlinking(false)
                        }
                    }}
                />
                <p>
                    {rangeValue != 0
                        ? t('map_distance', { postProcess: 'interval', count: rangeValue })
                        : t('exact position')}
                </p>
                <div
                    className={!isMobile() && rangeValue === 1000 ? 'cover cover_lite' : 'cover'}
                    style={{
                        width: `${(rangeValue / Number(maxRange)) * inputWidth}px`
                    }}
                ></div>
            </div>
            {!isMobile() ? (
                <p className={isBlinking ? 'mobileRequire threeTimesBlink' : 'mobileRequire'}>
                    {t('Higher precision only available on mobile devices')}
                </p>
            ) : (
                <></>
            )}
        </div>
    )
}

export default RangeInput
